import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import Company from '@business/general/Company';


export class CompanyTranslationGeneratedEntityManager<B extends CompanyTranslationGenerated> extends EntityTranslationManager<B>
{

    constructor(parameters: EntityManagerParameters<B>)
    {
        super({
            name: parameters.name ?? 'CompanyTranslation',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'company', type: BusinessEntityFieldType.ForeignKey, isRequiredInput: true, inputName: 'companyId', inputProperty: 'company.id', relatedManager: Company.manager },
				{ name: 'name', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'officialName', type: BusinessEntityFieldType.VarChar },
				{ name: 'addressLine1', type: BusinessEntityFieldType.VarChar },
				{ name: 'addressLine2', type: BusinessEntityFieldType.VarChar },
				{ name: 'cityName', type: BusinessEntityFieldType.VarChar },
				{ name: 'regionName', type: BusinessEntityFieldType.VarChar },
				{ name: 'countryName', type: BusinessEntityFieldType.VarChar },
				{ name: 'socialMediaFacebook', type: BusinessEntityFieldType.VarChar },
				{ name: 'socialMediaInstagram', type: BusinessEntityFieldType.VarChar },
				{ name: 'socialMediaLinkedin', type: BusinessEntityFieldType.VarChar },
				{ name: 'socialMediaYoutube', type: BusinessEntityFieldType.VarChar },
				{ name: 'socialMediaTiktok', type: BusinessEntityFieldType.VarChar },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'companyTranslations',
        });
    }

}
export class CompanyTranslationGenerated extends BusinessEntityTranslation
{
	/** The name of the foreign key to the translated entity. */
	translatedEntityForeignKeyName: string = 'company';
	/** The ID of the company this translation belongs to. */
	company!: Company;
	/** The translated name of the company. */
	name!: string;
	/** The official name of the company (for legal documents and invoices). */
	officialName: string = '';
	/** The translated first line of the address. */
	addressLine1: string = '';
	/** The translated second line of the address. */
	addressLine2: string = '';
	/** The translated city name. */
	cityName: string = '';
	/** The translated region or state name. */
	regionName: string = '';
	/** The translated country name. */
	countryName: string = '';
	/** The translated Facebook profile URL. */
	socialMediaFacebook: string = '';
	/** The translated Instagram profile URL. */
	socialMediaInstagram: string = '';
	/** The translated LinkedIn profile URL. */
	socialMediaLinkedin: string = '';
	/** The translated YouTube channel URL. */
	socialMediaYoutube: string = '';
	/** The translated TikTok profile URL. */
	socialMediaTiktok: string = '';

}

export default CompanyTranslationGenerated;